var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 37,
    viewBox: "0 0 218 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3224_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0006 5.31152L22.2762 15.3929H32.8762L24.3008 21.6233L27.5765 31.7047L19.0006 25.4742L10.4252 31.7047L13.7009 21.6233L5.125 15.3929H15.7249L19.0006 5.31152Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3224_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0006 5.31152L67.2762 15.3929H77.8762L69.3008 21.6233L72.5765 31.7047L64.0006 25.4742L55.4252 31.7047L58.7009 21.6233L50.125 15.3929H60.7249L64.0006 5.31152Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3224_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.001 5.31152L112.276 15.3929H122.876L114.301 21.6233L117.576 31.7047L109.001 25.4742L100.425 31.7047L103.701 21.6233L95.125 15.3929H105.725L109.001 5.31152Z",
    fill: "#211F1F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3224_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.001 5.31152L157.276 15.3929H167.876L159.301 21.6233L162.576 31.7047L154.001 25.4742L145.425 31.7047L148.701 21.6233L140.125 15.3929H150.725L154.001 5.31152Z",
    fill: "#211F1F"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3224_13065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.001 5.31152L202.276 15.3929H212.876L204.301 21.6233L207.576 31.7047L199.001 25.4742L190.425 31.7047L193.701 21.6233L185.125 15.3929H195.725L199.001 5.31152Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3224_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3224_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(45.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3224_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(90.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3224_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(135.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3224_13065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(180.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.1e36599130cfb8fafe3e68b87caa121c.svg";
export { ForwardRef as ReactComponent };